<template>
  <div>
    <div class="text-center depahead rsu">{{ labelOTP }}</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <v-btn color="primary" @click="query.view = 'Registration'" text class="pl-0"> <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK </v-btn>
      <div style="height: 60px; padding-top: 10px">
        <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
      </div>
      <div v-if="loading" class="text-center pt-10">
        <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
      </div>
      <v-container v-else>
        <div class="text-center mt-6" style="font-size: 30px; font-weight: 900; line-height: 40px">กรอก {{ labelOTP }}</div>
        <div class="text-center mb-4" style="color: grey">Refs: {{ ref }}</div>
        <ValidationObserver ref="observer">
          <ValidationProvider :name="labelOTP" :key="labelOTP" :rules="{ required: true }" v-slot="{ errors }">
            <div style="position: relative" class="inputdistance">
              <v-text-field type="tel" v-mask="'######'" height="3em" :name="labelOTP" :error-messages="errors" v-model="input.otp" :placeholder="labelOTP" outlined :hide-details="errors.length ? false : true" style="border-radius: 6px"></v-text-field>
            </div>
          </ValidationProvider>
        </ValidationObserver>
        <div class="flex-all-center mt-2">
          <div
            @click="resendOtp"
            class="text-center mb-3 mt-2"
            style="
              color: #162e50;
              background-color: #dadada;
              width: max-content;
              padding: 3px 18px;
              border: 1px solid transparent;
              border-radius: 8px;
            "
          >
            Resend {{ labelOTP }}
            <div style="color: red" v-if="errorSpam">
              กรุณารอ 1 นาทีจึงจะส่งได้อีกครั้ง
            </div>
          </div>
        </div>
        <div class="submitbtn mt-5">
          <v-btn :loading="saveloading" depressed @click="next" class="text-capitalize" color="primary" block>Next</v-btn>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      input: { otp: "" },
      saveloading: false,
      loading: false,
      ref: "",
      errorSpam: "",
    };
  },
  async mounted() {
    this.loading = true;
    await this.deparequestotp();
    this.loading = false;
  },
  computed: {
    labelOTP() {
      if (this.$store.state.typecb == "email") {
        return "Verification Code";
      } else {
        return "OTP";
      }
    },
  },
  methods: {
    async resendOtp() {
      var vm = this;
      var spamotp;
      if (localStorage.getItem("spamotp")) {
        spamotp = JSON.parse(localStorage.getItem("spamotp"));
        if (moment(spamotp).diff(moment(), "second") < 1) {
          localStorage.removeItem("spamotp");
          vm.errorSpam = "";
          await this.deparequestotp();
          this.$swal.fire({
            text: "ส่ง OTP ใหม่อีกครั้งสำเร็จ",
            icon: "success",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#152d53",
          });
        } else {
          vm.errorSpam = moment(spamotp).format("เวลา HH:mm วันที่ DD/MM/YYYY");
        }
      } else {
        await this.deparequestotp();
        this.$swal.fire({
          text: "ส่ง OTP ใหม่อีกครั้งสำเร็จ",
          icon: "success",
          confirmButtonText: "ยืนยัน",
          confirmButtonColor: "#152d53",
        });
        spamotp = moment().add(1, "minute");
        localStorage.setItem("spamotp", JSON.stringify(spamotp));
      }
    },
    deparequestotp() {
      let vm = this;
      return new Promise((resolve) => {
        var data = {
          pageid: this.query.pageid,
          userid: this.userid,
        };
        if (this.$store.state.typecb == "phone") {
          Object.assign(data, {
            phone_number: this.$store.state.input.username,
          });
        }
        if (this.$store.state.typecb == "email") {
          Object.assign(data, { email: this.$store.state.input.username });
        }
        axios
          .post(this.serverUrl + "deparequestotp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.ref = response.data.data[0].referral;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              vm.query.view = "Registration";
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
            resolve();
          });
      });
    },
    async next() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.saveloading = true;
        await this.verifyOTP();
      }
    },
    verifyOTP() {
      var vm = this;
      return new Promise((resolve) => {
        var data = {
          otp: this.input.otp,
          userid: this.userid,
          pageid: this.query.pageid,
          referral: this.ref,
        };

        axios
          .post(this.serverUrl + "depaverifyotp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.query.view = "Createpin";
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonText: "ยืนยัน",
                confirmButtonColor: "#152d53",
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
              resolve();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
.v-input input {
  max-height: inherit;
}
.inputdistance > .v-text-field input {
  font-size: 2em;
  text-align: center;
  /* height: 60px; */
  padding-right: 10px;
  padding-bottom: 10px;
}
.input-num {
  font-size: 1.5em;
  color: #3b63a5;
  position: absolute;
}
</style>
